import { Button, Col, Form, Row, Select } from "antd";
import { validateInput } from "../../../../tools/tools";
import Iinput from "../../../auxiliary/inputs/Input";
import { useEffect, useState } from "react";
import { useDealer } from "../../../../tools/api";

const Card = ({ t, creditCard, setCreditCard }) => {
	const [frmCard] = Form.useForm();
	const { queryBankCardProvider, assignCardToCustomer } = useDealer();

	const [card, setCard] = useState({
		cards: [],
		buttonProgress: false,
	});
	const submitHandler = async (values) => {
		try {
			const value = await frmCard.validateFields();
			setCard({ ...card, buttonProgress: true });
			const payload = {
				cardrefid: values.CardRefId,
				profileid: creditCard?.profileId,
				providerid: values.providerid,
				contractdocid: creditCard?.uploadResponses?.contract_moneytolia?.docId,
				productid: 20985,
				planid: process.env.REACT_APP_PLANID_ASSAIN_CARD_TURKEY,
				SkipPayment: values.SkipPayment,
			};
			const res = await assignCardToCustomer(payload);
			if (res) {
				setCreditCard((prev) => ({ ...prev, card: res, step: 4 }));
			}
			setCard({ ...card, buttonProgress: false });
		} catch (err) {
			setCard({ ...card, buttonProgress: false });
			console.error(err);
		}
	};
	useEffect(() => {
		const loadCard = async () => {
			const res = await queryBankCardProvider();
			setCard({ ...card, cards: res });
		};
		loadCard();
	}, []);
	return (
		<>
			<div className="g-body-format-page">
				<h3 className="header-of-form"></h3>
				<div className="holder-form">
					<Form id="frmCard" name="frmCard" form={frmCard} onFinish={submitHandler} layout="vertical">
						<Row gutter={30} justify={"start"}>
							<Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
								<Row gutter={30}>
									<Col xxl={15} xl={15} lg={20} md={20} sm={15} xs={24}>
										<Form.Item className="input-normal" name="providerid" label="نوع کارت" rules={[validateInput({ t, validate: true })]}>
											<Select placeholder="نوع کارت">
												{card.cards.map((type, key) => (
													<Select.Option key={key} value={type.value}>
														{type.name}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={30}>
									<Col xxl={15} xl={15} lg={20} md={20} sm={15} xs={24}>
										<Form.Item
											className="input-normal"
											name="CardRefId"
											label="شماره بارکد کارت"
											rules={[validateInput({ t, validate: true, type: "digit" })]}>
											<Iinput dir="ltr" />
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={30}>
									<Col xxl={15} xl={15} lg={20} md={20} sm={15} xs={24}>
										<Form.Item className="input-normal" name="SkipPayment" label="نحوی پرداخت" rules={[validateInput({ t, validate: true })]}>
											<Select placeholder="نحوی پرداخت">
												<Select.Option value={true}>پرداخت حضوری</Select.Option>
												<Select.Option value={false}>پرداخت آنلاین</Select.Option>
											</Select>
										</Form.Item>
									</Col>
								</Row>
							</Col>
							<Col xxl={12} xl={12} lg={12} md={12} sm={0} xs={0}>
								<img
									style={{ width: "100%", borderRadius: "0.75rem" }}
									src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/cards.png"}
									alt=""
								/>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
			<div className="g-footer-format-page">
				<div className="holder-button">
					<Button className="btn-normal btn-aptel" loading={card.buttonProgress} type="primary" htmlType="submit" form="frmCard">
						مرحله بعد
					</Button>

					<Button type="default" className="btn-normal " onClick={() => setCreditCard({ ...creditCard, step: 2 })}>
						بازگشت
					</Button>
				</div>
			</div>
		</>
	);
};

export default Card;
